import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SearchDropdownMenuComp from 'components/SearchDropdown/SearchDropdownMenu';
import classes from './SearchDropdown.module.scss';

export class SearchDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      styles: {
        left: 0,
        top: 0
      }
    };
    this.handleResize = this.updateMenuLocation.bind(this);
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  UNSAFE_componentWillReceiveProps() {
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  updateMenuLocation() {
    const leftOrientation = this.button.offsetLeft;

    const topOrientation = this.button.offsetHeight + this.button.offsetTop + 10;

    this.setState({
      styles: {
        top: topOrientation,
        left: leftOrientation,
        ...(this.props.styles || {})
      }
    });
  }

  render = () => (
    <div className={classes.dropdownContainer}>
      <div
        ref={(elt) => {
          this.button = elt;
        }}
      >
        {this.props.buttonComponent}
      </div>
      {this.props.isVisible ? (
        <SearchDropdownMenuComp
          clickOutsideHandler={this.props.clickOutsideHandler}
          menuComponent={this.props.menuComponent}
          buttonRef={this.button}
          maxItems={this.props.maxItems}
          itemHeight={this.props.itemHeight}
          styles={this.state.styles}
        />
      ) : (
        ''
      )}
    </div>
  );
}

SearchDropdown.propTypes = {
  buttonComponent: PT.element.isRequired,
  menuComponent: PT.element.isRequired,
  clickOutsideHandler: PT.func,
  isVisible: PT.bool,
  maxItems: PT.number,
  itemHeight: PT.number,
  styles: PT.any
};

export default SearchDropdown;
